import React from 'react';

const DotLoading = () => <div className="dots-loading"/>;
export default DotLoading;